import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  min-width: 0;
  overflow-wrap: anywhere;
  color: ${({ theme }) => theme.palette.text.primary};
`;

// A blank line at body2's 1.4rem × 1.4 line box — the same gap mobile's renderer writes as a
// double newline, so a description reads with one rhythm on both platforms.
const BLOCK_GAP = 5;

export const List = styled.ul`
  margin: 0;
  padding-left: ${({ theme }) => theme.spacing(5)};

  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing(BLOCK_GAP)};
  }
`;

export const OrderedList = styled.ol`
  margin: 0;
  padding-left: ${({ theme }) => theme.spacing(5)};

  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing(BLOCK_GAP)};
  }
`;

export const ListItem = styled.li`
  margin: 0;
`;

// Provider descriptions arrive as one run of blocks; only the gap between them is styled,
// so the row keeps the form's rhythm instead of the browser's default paragraph margins.
// The gap hangs off every paragraph but the first — not off `p + p` — so a paragraph after a
// div or a list is spaced too, matching mobile's per-node separator.
export const Paragraph = styled.p`
  margin: 0;

  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.spacing(BLOCK_GAP)};
  }
`;

export const Block = styled.div`
  margin: 0;
`;
